import { render, staticRenderFns } from "./editAccountGroup.vue?vue&type=template&id=38e82e84&scoped=true"
import script from "./editAccountGroup.vue?vue&type=script&lang=ts"
export * from "./editAccountGroup.vue?vue&type=script&lang=ts"
import style0 from "./editAccountGroup.vue?vue&type=style&index=0&id=38e82e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e82e84",
  null
  
)

export default component.exports